export enum ErrorEnum {
    needToRefreshToken = 11019,
    sessionExpired = 17144,
    authorizationInfoIsBroken = 17145,
    communityWithNameNotFound = 18082,
    accessDeniedToCommunity = 17146,
    youDontHaveAccessToAnyCommunity = 17148,
    yourAccountIsLocked = 17147,
    invalidVerificationCode = 17149,
}
